import { useParams, Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { POLICIES } from "@/seo/meta";

export default function Policy() {
  const { slug } = useParams();
  const title = POLICIES[slug] || "Policy";
  return (
    <PublicLayout>
      <article className="mx-auto max-w-3xl px-5 py-12 sm:px-8 sm:py-16 fade-up">
        <nav aria-label="Breadcrumb" data-testid="policy-breadcrumbs" className="-ml-2 mb-4">
          <ol className="flex items-center gap-1 text-[13px] text-muted-foreground">
            <li><Link to="/" className="inline-flex min-h-[44px] items-center px-2 hover:text-foreground transition-colors">Home</Link></li>
            <li aria-hidden="true" className="text-[#E9C98B]/70">›</li>
            <li aria-current="page" className="px-2 text-[#F3DDAE]">{title}</li>
          </ol>
        </nav>
        <span data-testid="policy-beta-draft-badge" className="inline-block rounded-full border border-[#E9C98B]/40 bg-[#E9C98B]/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-[#F3DDAE]">
          Beta draft
        </span>
        <h1 data-testid="policy-title" className="mt-4 text-3xl sm:text-4xl font-medium">{title}</h1>
        <div className="mt-6 space-y-4 text-muted-foreground leading-relaxed">
          <p>This is a Beta draft placeholder. The final {title.toLowerCase()} will be reviewed by a lawyer before AetherTags leaves the free beta.</p>
          <p>During the beta, AetherTags is free. We read your shop's listings through Etsy's official API only after you connect it, store only what we need to run the features you use (listing content, version history and daily stats), and delete stored Etsy tokens and shop data when you disconnect.</p>
          <p>AI suggestions are generated by a third-party model provider on settings that do not train on your content. You remain responsible for the accuracy of your listings and for Etsy's own disclosure rules.</p>
          <p>AetherTags does not guarantee rankings, traffic or sales. Results are associated with changes, not guaranteed.</p>
        </div>
        <Link to="/" data-testid="policy-back-link" className="mt-8 inline-flex min-h-[44px] items-center text-primary hover:underline">← Back to AetherTags</Link>
      </article>
    </PublicLayout>
  );
}
